import { Alert, Button, Form, Input, Space, Typography } from 'antd'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../modules/auth/contexts/Auth'
import { emailRule, requiredRule } from '../../utils/rules'

const { Title } = Typography

const ForgotPasswordPage = () => {
  const { forgotPassword } = useAuth()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [result, setResult] = useState<string | undefined>(undefined)

  const handleSubmit = (values: { email: string }) => {
    setIsLoading(true)
    setResult(undefined)
    forgotPassword(values.email).finally(() => {
      setResult('Forgot password request processed')
      setIsLoading(false)
    })
  }
  return (
    <Space orientation="vertical" className="w-full">
      {result && (
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <Alert style={{ marginBottom: 25 }} title={result} type="success" />
        </div>
      )}
      <Title className="m-0" level={5}>
        Forgot password
      </Title>
      <Form onFinish={handleSubmit}>
        <Form.Item name="email" rules={[requiredRule(), emailRule()]}>
          <Input
            size="large"
            className="authField"
            placeholder={'Email'}
            autoComplete="email"
          />
        </Form.Item>
        <Form.Item style={{ marginBottom: 15 }}>
          <Button
            size="large"
            className="w-full"
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            Send reset link
          </Button>
        </Form.Item>
      </Form>
      <Space
        style={{ alignItems: 'center', width: '100%' }}
        orientation="vertical"
      >
        <Link to={'/auth/login'}>Already have an account ? Login</Link>
      </Space>
    </Space>
  )
}

export default ForgotPasswordPage
